import { LandscapeImageCard } from '@bnnvara/cards';
import truncate from 'lodash/truncate';
import PropTypes from 'prop-types';
import React from 'react';

import resizeImageSource from '../../../helpers/resizeImageSource';
import truncateTitle from '../../../helpers/truncateTitle';

const CatalogItemCard = ({ title, photo, description }) => {
  const background = photo
    ? resizeImageSource(photo.url, 450)
    : '/static/fallbackImages/videofallback.jpg';

  const truncatedDescription =
    description &&
    truncate(description, {
      length: 130,
    });

  return (
    <LandscapeImageCard
      title={truncateTitle(title)}
      thumbnail={background}
      description={truncatedDescription}
    />
  );
};

CatalogItemCard.defaultProps = {
  photo: null,
};

CatalogItemCard.propTypes = {
  photo: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }),
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export default CatalogItemCard;
